import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import React from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllPreauthorizationList,
  GetPreauthorizationEligibility,
  GetPreauthorizationRequest,
  ReUseWithoutEdit,
  ViewPreauthorization,
} from "../config/preauthorizationApi";
import moment from "moment";
import { toast } from "react-toastify";
import { getPathFromUrl } from "helpers/utils";

const ReuseModal = ({ show, onClose, row, page, rowsPerPage }) => {
  const dispatch = useDispatch();
  const { preauthorizationFilters } = useSelector(
    (state) => state.preauthorization
  );

  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));

  const navigate = useNavigate();

  const requestBody = () => ({
    branch_id: selectedBranch?.value || 1,
    insurance_company_id:
      preauthorizationFilters?.insurance?.insurance_company_id || "",
    claim_type:
      preauthorizationFilters?.preauthorization_type?.claim_types_id || "",
    claimsub_types_name:
      preauthorizationFilters?.preauthorization_sub_type?.claimsub_types_id ||
      "",
    ref_number: preauthorizationFilters?.reference_number || "",
    frm_dte: preauthorizationFilters?.start_date
      ? moment(preauthorizationFilters?.start_date).format("DD-MM-YYYY")
      : "",
    to_dte: preauthorizationFilters?.end_date
      ? moment(preauthorizationFilters?.end_date).format("DD-MM-YYYY")
      : "",
    ident_typ: preauthorizationFilters?.identity_type?.ident_type_id || "",
    pat_det: preauthorizationFilters?.patient || "",
    preauth_sts:
      preauthorizationFilters?.preauthorization_status?.allstatus_code || "",
    start_point: page,
    limit: rowsPerPage,
  });

  const fetchPreauthorizationList = async (body = {}) => {
    try {
      const response = await dispatch(
        GetAllPreauthorizationList(body)
      ).unwrap();
    } catch (error) {
      // toast.error("Something Went Wrong");
    }
  };

  const handleCheckListFilter = () => {
    const body = requestBody();
    fetchPreauthorizationList(body);
  };

  const onConfirm = async () => {
    const response = await dispatch(
      ViewPreauthorization({
        preauthid:
          row?.preauthinspro_id ||
          row?.preauthpharmcy_id ||
          row?.preauthfull_id ||
          row?.preauthvision_id,
        claim_type: row?.claim_type,
      })
    ).unwrap();

    if (response?.success) {
      navigate(
        `${paths.preauthorization}?preauthid=${
          row?.preauthinspro_id ||
          row?.preauthpharmcy_id ||
          row?.preauthfull_id ||
          row?.preauthvision_id
        }&reuse=true`
      );
    }
  };

  const reuseWithoutEdit = async () => {
    const response = await dispatch(
      ReUseWithoutEdit({
        preauthid:
          row?.preauthinspro_id ||
          row?.preauthpharmcy_id ||
          row?.preauthfull_id ||
          row?.preauthvision_id,
        claim_type: row?.claim_type,
      })
    ).unwrap();

    if (response?.status_code === "200") {
      toast.success(response?.message_en);
      handleCheckListFilter();
      onClose();
    }
  };

  return (
    <Modal show={show} centered dialogClassName="wizard-modal">
      <Modal.Body>
        <FalconCloseButton
          onClick={onClose}
          size="sm"
          className="position-absolute top-0 end-0 me-2 mt-2"
        />
        <Flex direction="column" alignItems="center" className="mb-3">
          <h6 className="fs-9 text-700">Reuse This Entry</h6>
          <h6 className="fs-11 text-400 text-center">
            Do you Want Edit the current request before you Submit again as new?
          </h6>
        </Flex>

        <hr />
        <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
          <Button variant="danger" size="sm" onClick={reuseWithoutEdit}>
            No
          </Button>
          <Button variant="success" size="sm" onClick={onConfirm}>
            Yes
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

ReuseModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ReuseModal;
